import React from 'react';
import { useParams } from "react-router-dom";
import MainLayout from '../Layouts/MainLayout';
import '../CSS/SectorPage.css';
import BlogCard from '../Components/BlogCard';
import { useSectorPosts } from '../Utlis/useFetchData';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Loading from '../Components/Loading';
import Error from '../Pages/Error';
const SectorPage = () => {
  const { category } = useParams();
  const { data: blogPosts, error, loading } = useSectorPosts(category);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : error ? (
        (<Error />)
      ) : (
        <div>
          <HelmetProvider>
            <Helmet>
              <title>{category ? `${category} - BlogWiki` : 'BlogWiki'}</title>
              <meta name="description" content={`Read the latest posts in the ${category} category on BlogWiki`} />
            </Helmet>
          </HelmetProvider>
          <MainLayout>
            <div className="SectorMainWrapper">
              {blogPosts && blogPosts.map((value) => (
                <BlogCard
                  key={value._id}
                  img={value.thumbnailUrl}
                  title={value.title}
                  description={value.content}
                  author={value.author}
                  ids={value._id}
                  date={value.createdAt}
                  sector ={value.Sector}
                />
              ))}
            </div>
          </MainLayout>
        </div>
      )}
    </div>
  );
};

export default SectorPage;
